// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"301":"a304bae5","453":"311b3dbc","918":"4eb5e187"}[chunkId] + ".chunk.js";
};